import { Directive, Input, TemplateRef, inject } from '@angular/core';

/**
 * Common table cell by group
 */
@Directive({
  selector: '[mbsTableControl]'
})
export class TableControlDirective {
  template = inject<TemplateRef<any>>(TemplateRef);

  @Input('mbsTableControl') public mode: 'append' | 'prepend' = 'append';
}
